/**
 * Envíos: tarifas por zona y días de preparación del merch propio.
 */

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { notify } from '@/lib/notify';
import { useMerchPrepDays, useSetMerchPrepDays } from '../settings/useStoreBrands';
import { StoreShippingRatesPage } from './StoreShippingRatesPage';

export function StoreShippingPage() {
    const prep = useMerchPrepDays();
    const save = useSetMerchPrepDays();
    const [days, setDays] = useState('');
    const [seen, setSeen] = useState<number | null>(null);
    if (prep.data != null && seen !== prep.data) {
        setSeen(prep.data);
        setDays(String(prep.data));
    }

    return (
        <div className="space-y-6">
            <section className="max-w-sm space-y-2 rounded-xl border border-border p-4">
                <Label htmlFor="merch-prep">Preparación del merch (días)</Label>
                <p className="text-xs text-muted-foreground">
                    Se suma a los días de la zona. Un carrito solo de merch también muestra la entrega estimada.
                </p>
                <div className="flex gap-2">
                    <Input
                        id="merch-prep"
                        inputMode="numeric"
                        value={days}
                        onChange={(event) => setDays(event.target.value)}
                    />
                    <Button
                        type="button"
                        disabled={save.isPending}
                        onClick={() => {
                            const value = Number(days);
                            if (!Number.isInteger(value) || value < 0 || value > 60) {
                                notify({ type: 'err', text: 'Escribe un número de días entre 0 y 60' });
                                return;
                            }
                            save.mutate(value, {
                                onSuccess: () => notify({ type: 'ok', text: 'Preparación del merch guardada' }),
                                onError: (error) => notify({ type: 'err', text: error.message }),
                            });
                        }}
                    >
                        Guardar
                    </Button>
                </div>
            </section>
            <StoreShippingRatesPage />
        </div>
    );
}
